import generateRoundUpPhrases from "./generateRoundUpPhrases";
import tempScript from "./tempScript";

export default [tempScript, generateRoundUpPhrases];
